import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Empty } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import usecustomStyles from '../../Common/customStyles';
import * as SThunk from '../../slices/statistics/thunk';

const customStyles = usecustomStyles();

const Top5AlarmTypesByDailyCount = ({ style, vehicleListData }) => {
    const alarmType = useSelector(state => state.Statistics.alarmType);
    const user = useSelector(state => state.Login.user);
    const [alarmTypes, setAlarmTypes] = useState([]);
    const payload = {
        'role': user.user?.role || '',
        "startDate": moment().startOf('day').format('YYYY-MM-DD'),
        "endDate": moment().format('YYYY-MM-DD'),
    }

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(SThunk.alarmType(payload));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let countList = _.entries(alarmType).map(x => ({ name: x[0], value: x[1] }));
        countList = _.orderBy(countList, ['value', 'name'], ['desc', 'asc']);
        const topList = countList.map((item,i) => (
            <li key={item.name} className='card-list-li'>
                <div style={{ display: 'flex', justifyContent:'space-between' }}>
                    <span>
                        <span style={{ margin: '0.5em' }}>{i + 1}.</span> <span>{item.name}</span>
                    </span> {' '}
                    <b style={{ marginRight: '0.5em' }}>{item.value}</b>
                </div>
            </li>
        ));

        setAlarmTypes(topList);
    }, [alarmType, vehicleListData]);

    const EmptyItem = <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }} />;
    return (
        <Card title="(今日)报警类型 - TOP 5" style={style}>
            {alarmTypes && alarmTypes.length > 0 ? <ul style={{ listStyleType: 'none', padding: 0 }}>{alarmTypes}</ul> : EmptyItem}
        </Card>
    );
};

export default Top5AlarmTypesByDailyCount;
